<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      {{trainPlain.trainingName}}
      <span style="font-size:16px;margin-left:20px">比赛开始时间： {{trainPlain.trainingTime | time(true)}}</span>
    </template>
    <template v-slot:nav_right>
      <div v-if=" userRole !== 'player'" class="download_btn" @click="download(trainPlain.uuid)">下载</div>
    </template>
    <div class="scroll_wrap">
      <vue-scroll v-show="!loading">
        <div class="item_title" style="padding-top:20px">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          基本信息
        </div>
        <div class="item">
          <div class="col">
            <span>主教练：{{trainPlain.chiefCoachName}}</span>
            <span>比赛时长：{{parseInt(trainPlain.trainingTotalTime / 60)}} 小时 {{trainPlain.trainingTotalTime % 60}} 分钟</span>
          </div>
          <div class="col">
            <span>比赛地点：{{trainPlain.trainingPlace || '--'}}</span>
            <span>对手实力：{{trainPlain.trainingAmount || '--'}}</span>
            <span>比赛强度：{{trainPlain.trainingIntensity  ||  '--'}}</span>
          </div>
          <div class="col" style="justify-content: left" >
            <div style="display: flex;flex-wrap: wrap">
              <div >
                比赛总体描述：
              </div>
              <div v-html="trainPlain.overallEvalComment || '--'"></div>
            </div>
          </div>
        </div>
        <div class="item_title">
          <img src="@/assets/images/common/qc.png" style="width:30px;height:30px" alt="">
          比赛报告
        </div>
        <div class="item">
          <div class="col head">
            <span>项目</span>
            <span>分类</span>
            <span>时长</span>
          </div>
          <div v-for="(item, index) in tutorial" :key="index" class="col">
            <span>{{item.trainingTitle}}</span>
            <span>{{item.drillCategoryZh || '--'}}</span>
            <span>{{item.timeSpent}}分钟</span>
          </div>
        </div>
        <div v-for="(item, index) in tutorial" :key="index" >
          <div class="item_title">
            <img src="@/assets/images/common/train_summary.png" style="width:24px;height:18px" alt="">
            {{item.trainingTitle}}
            <span>分类：{{item.drillCategoryZh || '--'}}</span>
            <span>环节时长：{{item.timeSpent}} {{$t('hours')}}</span>
          </div>
          <div class="item_link">
            <div class="col">
              <span class="title">基本信息</span>
              <div class="flex"><img :src="item.coverImgUrl"  style="width:330px;height:178px" @error="item.coverImgUrl = placeHolderImg"></div>
            </div>
            <div class="col">
              <span class="title">比赛描述</span>
              <div class="flex" v-html="item.drillComment || '--'"></div>
            </div>
          </div>
        </div>
        <div class="item_title">
          <img src="@/assets/images/common/link_icon.png" style="width:20px;height:20px" alt="">
          全队比赛总结
        </div>
        <div class="item">
          <div class="col">
            <span>{{trainPlain.trainingSummary}}</span>
          </div>
        </div>
        <div class="item_title">
          <img src="@/assets/images/common/videoIcon.png" style="width:.3rem;height.3rem" alt="">
          视频
        </div>
        <div class="trainPlan">
          <div
            v-for="(item,index) in videoToPlayerVos"
            :key="index"
            class="mediaDetail"
            @click.stop="goDetail(item.uuid)">
            <div class="img">
              <img
                class="playImg"
                :src="playImg"
                style="position: absolute;top: 30px;left: 65px;"
                @click.stop="openVideoDialog(item.videoAddress,item.videoCoverAddress)">
              <img
                class="coverImg "
                :src="item.videoCoverAddress || planImg"
                alt=""
                style="width: 170px;height:100px"
                @error="item.videoCoverAddress === planImg" >
            </div>
            <div class="intro">
              <p class="p_item">标题：{{item.videoTitle || '--'}}</p>
              <p class="p_item">上传人：{{item.authorName}}</p>
              <p >时长： {{filterTime(parseInt(item.videoDuration / 60))}}:{{ filterTime(item.videoDuration % 60)}}</p>
            </div>
          </div>
        </div>
        <yioks-empty v-show="videoToPlayerVos.length === 0" :h="'150px'"></yioks-empty>
        <div>
          <div class="item_title">
            <img src="@/assets/images/common/group_member.png" style="width:25px;height:20px" alt="">
           全队球员<div style="font-size:18px" v-if="Number(trainPlain.commentStatus)">（球员数量：{{players.length}}个）</div>
          </div>
          <div v-if="Number(trainPlain.commentStatus)">
            <div v-for="(item, index) in players" :key="index" class="item_squad" v-if=" userRole === 'player'? uuid === item.playerUuid : true">
              <div class="flex_center">
                <img :src="item.headImgUrl ? item.headImgUrl :person " @error="item.headImgUrl = person">
                <p>{{item.idName}}</p>
                <p>出勤率：{{item.attendance}}%</p>
                <p>{{item.positionId | positionStatus}}</p>
              </div>
              <div class="flex">
                <div class="head">个人比赛目标</div>
                <div class="content" style="text-align: center" >{{item.learningObjectives || '--'}}</div>
                <div class="col">
                  <span>技术</span>
                  <span>战术</span>
                </div>
                <div class="col">
                  <span>{{item.technicalScore}}分</span>
                  <span>{{item.tacticalScore}}分</span>
                </div>
              </div>
              <div class="flex">
                <div class="head">个人比赛评价</div>
                <div class="content">{{item.generalEvalComments || '--'}}</div>
                <div class="col">
                  <span>体能</span>
                  <span>心理</span>
                </div>
                <div class="col">
                  <span>{{item.physicalScore}}分</span>
                  <span>{{item.psychologicalScore}}分</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <yioks-empty :h="'150px'" :tips="'暂时没有球员评价'"></yioks-empty>
          </div>
        </div>
      </vue-scroll>
      <yioks-loading v-if="loading"></yioks-loading>
    </div>
    <template v-if="showVideo">
      <el-dialog
        :visible.sync="showVideo"
        width="800px"
        class="linkAllDialog"
        :close-on-click-modal="false"
        top="12vh">
        <div style="text-align: center;background-color: black;width: 760px" >
          <video
            ref="video"
            controls
            width="760"
            autoplay
            disablePictureInPicture
            :poster="poster"
            controlsList = "nodownload noremoteplayback"
            height="400">
            <source :src="videoSrc" type="video/mp4">
          </video>
        </div>
      </el-dialog>
    </template>
  </SubContent>
</template>

<script>

import person from '@/assets/images/common/person.jpg'
import storage from '@/utils/storage'
import teaching from '@/api/teaching'
import placeHolderImg from '@/assets/images/common/plan_default.png'
import { positionStatus } from '@/utils/yioks_filter'
import common from '@/api/common'
import media from '@/api/media'
import playImg from '@/assets/images/common/playImg.png'
export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent')
  },
  filters: {
    dataEmpty (val) {
      if (!val) return '--'
    },
    positionStatus
  },
  data () {
    return {
      person,
      playImg,
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      downIng: false,
      loading: true,
      trainUuid: this.$route.query.uuid,
      trainPlain: {},
      tutorial: [],
      players: [],
      videoToPlayerVos: [],
      showVideo: false,
      placeHolderImg
    }
  },
  created () {
    this.getPlanDetail()
  },
  methods: {
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    getPlanDetail () {
      teaching.infoMatchTrainingPlanCompleteStatus({trainingPlanUuid: this.trainUuid}).then(res => {
        this.loading = false
        if (res.code) {
          this.$router.push('/home/index')
        } else {
          this.trainPlain = res.planInformationInfo
          this.tutorial = res.drillInformationInfos
          this.players = res.playerInformationInfo
          this.videoToPlayerVos = res.videos
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    download (uuid) {
      if (this.downIng) return
      this.downIng = true
      teaching.matchTrainingPlanDownLoadPdf({ trainingPlanUuid: uuid }).then(res => {
        const { fileName, filePath } = res
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
          common.downfile(transferPath, fileName);
        this.downIng = false
      }).catch(err => {
        this.downIng = false
      })
    },
    openVideoDialog (src, poster) {
      this.videoSrc = src
      this.poster = poster || ''
      this.showVideo = true
    },
    goDetail (uuid) {
      this.$router.push({
        path: '/media/detail',
        query: {
          uuid
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .download_btn
    background $green_color
    padding 10px 20px
    font-size 16px
    cursor pointer
  .scroll_wrap
    flex 1
    overflow hidden
    box-sizing border-box
    padding 20px 0
    .item_title
      display flex
      align-items center
      font-size 20px
      padding 40px 0 20px
      margin 0 30px
      span
        margin-left 40px
        font-size 16px
      img
        margin-right 10px
    .item
      border 1px solid #FFF
      margin 0 30px
      .head
        font-weight bold
      .center
        text-align center
      .col
        display flex
        border-bottom 1px solid #FFF
        justify-content space-around
        padding 10px 20px
        span
          width 100%
        &:last-child
          border none
    .trainPlan
      display flex
      justify-content space-between
      flex-wrap wrap
      margin: 0 .3rem;
      .planDetail
        border  1px solid white
        width 100%
        .row
          min-height 49px
          display flex
          align-items center
          border-bottom 1px solid white
          &:last-child
            border-bottom   none
          .col
            width:  50%
            padding 0 10px 0 20px
            height 100%
            line-height 49px
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &:first-child
              border-right  1px solid white
        .rowLine
          padding: 10px  10px  10px 20px
      .mediaDetail
        background-color rgba(0,0,0,0.7)
        border  1px solid white
        padding  20px
        width 400px
        display flex
        align-items center
        cursor pointer
        margin-bottom 20px
        .p_item
          margin-bottom 10px
      .img
        width 170px
        height 100px
        position relative
        .coverImg
          width 100%
          height 100%
      .intro
        padding-left 10px
        width: calc(100% - 170px);
        height 100px
        display flex
        flex-direction column
        justify-content space-between
    .item_link
      border 1px solid #FFF
      margin 0 30px
      .col
        display flex
        border-bottom 1px solid #FFF
        &:last-child
          border none
        .title
          width: 150px
          padding 10px 5px
        .flex
          flex 1
          padding 10px 20px
          border-left 1px solid #FFF
    .item_squad
      border 1px solid #FFF
      margin 0 30px 20px
      border-right 0
      display flex
      .flex
        flex 1
      .flex_center
        display flex
        flex-direction column
        justify-content center
        align-items center
        padding 0 10px
        border-right 1px solid #FFF
        img
          width 60px
          height 60px
          border-radius 50%
          margin-bottom 10px
        p
          margin-bottom 10px
      .head,.content
        padding 20px
        text-align center
        border-right 1px solid #FFF
        border-bottom 1px solid #FFF
      .content
        min-height 60px
      .col
        display flex
        justify-content space-around
        border-bottom 1px solid #FFF
        &:last-child
          border none
        span
          width 100%
          text-align center
          border-right 1px solid #FFF
          padding 10px 20px
</style>
